import UserAccountSettings from './UserAccountSettings/UserAccountSettings';

/**
 * Unified Profile and Settings Component
 * Refactored into modular components under ./UserAccountSettings/
 */
export default UserAccountSettings;